import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const StyledPrescriptionVisitHeader = styled.header`
   display: flex;
   flex-direction: column;
   gap: 4px;
   width: 100%;
`;

StyledPrescriptionVisitHeader.displayName = 'StyledPrescriptionVisitHeader';

export const StyledPrescriptionVisitHeaderPatientContent = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: 8px;
   overflow: hidden;
   flex: 1;
`;

StyledPrescriptionVisitHeaderPatientContent.displayName = 'StyledPrescriptionVisitHeaderPatientContent';

export const StyledPrescriptionVisitHeaderDetails = styled.div`
   ${basicBodyTextStyle};
   display: flex;
   flex-wrap: wrap;
   gap: 4px 16px;
`;

StyledPrescriptionVisitHeaderDetails.displayName = 'StyledPrescriptionVisitHeaderDetails';
